var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',_vm._g(_vm._b({},'el-radio-group',_vm.$attrs,false),_vm.$listeners),[_c('el-radio',{attrs:{"label":0}},[_vm._v(_vm._s(_vm._f("status")(0)))]),_c('el-radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm._f("status")(1)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }